export enum EstadoMantisEnum {
    PENDIENTE = 'pendiente',
    RESUELTA = 'resuelta',
    CERRADA = 'cerrada'
}
